export default __webpack_public_path__ + "static/media/onboardingBg.44a50e7e.png";